import React from 'react';
import { XIcon, StarIcon, CheckIcon, TagIcon } from './icons';

interface FloatingSynthesisBarProps {
    selectedCount: number;
    onClear: () => void;
    onMarkReviewed: () => void;
    onStar: () => void;
    onTag: () => void; // For future implementation of bulk tagging modal
}

const FloatingSynthesisBar: React.FC<FloatingSynthesisBarProps> = ({
    selectedCount,
    onClear,
    onMarkReviewed,
    onStar,
    onTag
}) => {
    if (selectedCount === 0) return null;

    return (
        <div className="fixed bottom-8 left-1/2 -translate-x-1/2 bg-action text-white px-6 py-3 rounded-full shadow-float flex items-center gap-6 z-50 animate-bounce-in">
            <div className="flex items-center gap-3 border-r border-white/20 pr-6 mr-2">
                <span className="font-bold font-mono text-lg">{selectedCount}</span>
                <span className="text-sm font-medium mr-2">Selected</span>
                <button
                    onClick={(e) => { e.stopPropagation(); onClear(); }}
                    className="p-1 rounded-full hover:bg-white/20 transition-colors"
                    title="Clear Selection"
                >
                    <XIcon className="w-4 h-4" />
                </button>
            </div>

            <div className="flex items-center gap-2">
                <button
                    onClick={(e) => { e.stopPropagation(); onMarkReviewed(); }}
                    className="flex items-center gap-2 px-3 py-1.5 rounded-lg hover:bg-white/10 transition-colors text-sm font-medium"
                    title="Mark as Reviewed"
                >
                    <CheckIcon className="w-4 h-4" />
                    <span>Review</span>
                </button>

                <button
                    onClick={(e) => { e.stopPropagation(); onStar(); }}
                    className="flex items-center gap-2 px-3 py-1.5 rounded-lg hover:bg-white/10 transition-colors text-sm font-medium"
                    title="Star / Highlight"
                >
                    <StarIcon className="w-4 h-4" />
                    <span>Star</span>
                </button>

                <button
                    onClick={(e) => { e.stopPropagation(); onTag(); }}
                    className="flex items-center gap-2 px-3 py-1.5 rounded-lg hover:bg-white/10 transition-colors text-sm font-medium"
                    title="Add Tags"
                >
                    <TagIcon className="w-4 h-4" />
                    <span>Tag</span>
                </button>
            </div>
        </div>
    );
};

export default FloatingSynthesisBar;
